import React, { Dispatch } from 'react';
import classes from './FindImageFilterMenu.module.scss';
import { FindImagesSourceFilterGroup } from '../../../../components/filters/FindImagesSourceFilterGroup';
import { FindImagesProportionFilterGroup } from '../../../../components/filters/FindImagesProportionFilterGroup';
import { FindImagesTypeFilterGroup } from '../../../../components/filters/FindImagesTypeFilterGroup';
import { FindImagesFilterAction, FindImagesFilterType } from '../../../../models/media';
import { FindImagesSource } from '../../../../constants/media';

export type FindImageFilterMenuViewProps = {
  loading: boolean;
  isFilterActive: boolean;
  filters: FindImagesFilterType;
  dispatchFilters: Dispatch<FindImagesFilterAction>;
};

export const FindImageFilterMenuView = (props: FindImageFilterMenuViewProps): JSX.Element => {
  return (
    <div className={classes.ModalFilterButtonMenu}>
      <FindImagesSourceFilterGroup
        loading={false}
        dispatchFilters={props.dispatchFilters}
        activeFilterId={props.filters.source || undefined}
      />
      {props.filters.source === FindImagesSource.PIXABAY && (
        <>
          <FindImagesProportionFilterGroup
            loading={false}
            dispatchFilters={props.dispatchFilters}
            activeFilterId={props.filters.proportion || undefined}
          />
          <FindImagesTypeFilterGroup
            loading={false}
            dispatchFilters={props.dispatchFilters}
            activeFilterId={props.filters.type || undefined}
          />
        </>
      )}
    </div>
  );
};
